import React from "react";
import { Link, useNavigate } from "react-router-dom";
import amazon from "../logos/amazon.jpg";
const SignUp = (props) => {
  const [name, setName] = React.useState("");
  const navigate = useNavigate();
  const handleSubmit = (e) => {
    e.preventDefault();
    props.setValues(name);
    setName("");
    navigate("/dashboard");
  };
  return (
    <div className="signup-page">
      <img src={amazon} alt="" className="amazon-logo" />
      <div className="signup-form">
        <form onSubmit={handleSubmit}>
          <h2>Create Account</h2>
          <label htmlFor="name">Your name</label>
          <input
            type="text"
            className="input-field"
            id="name"
            placeholder="first name and last name"
            required
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <label htmlFor="email">Mobile number or email</label>
          <input type="email" id="email" required className="input-field" />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            className="input-field"
            required
            placeholder="At least 8 characters"
            minLength="8"
          />
          <label htmlFor="password-again">Re-enter Password</label>
          <input
            type="password"
            id="password-again"
            className="input-field"
            required
            minLength="8"
          />
          <button className="btn btn-continue">Continue</button>
          <div>
            <p className="form-text">
              By creating an account, you agree to Amazon's
              <Link className="link" to="/about">
                Conditions of Use
              </Link>
              and
              <Link className="link" to="/about">
                Privacy Notice
              </Link>
              .
            </p>
          </div>
          <p className="form-text">
            Already have an Account
            <Link className="link" to="/login">
              Sign in
            </Link>
          </p>
          <p className="form-text">
            Buying for Work?
            <Link className="link" to="/businessaccount">
              Create a free business account
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};
export default SignUp;
